<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="megaphone-outline"></ion-icon> Human Resources</h4>
  </div>
  <div class="content-details">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Objective">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              One of the important aspects of an Incubation Center is having an
              experienced leadership team and operations staff across ranks to
              support the various initiatives of the Incubator. In addition to
              support to the Startups hosted by them, the Incubation personnel
              must be willing to learn constantly to evolve and serve the
              Incubatees better. Also the initiative undertaken by the incubator
              to continously train and develop, Human Resources by training them
              and help participate in skill / knowledge development in operating
              / managing the incubator.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Phases">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>
              Acquisition, development and termination are three key phases in
              human resources management. These phases are also termed as
              pre-hiring, training and post-hiring phases.
            </li>
          </ul>
        </div>
      </mat-tab>
      <mat-tab label="Scoring Criteria">
        <div class="content-div p-4">
          <ul class="objective-ul">
            <li>Team Structure; Policies; Management</li>
          </ul>
        </div>
      </mat-tab>
    </mat-tab-group>

    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div
          class="col-lg-12 col-md-12 col-sm-12 col-12"
          [formGroup]="settingsForm"
        >
          <mat-accordion>
            <!-- qusetion 001 upload09 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Availability of a dedicated full time Incubation Team
                    (Director, Chief Executive Officer and other Incubation
                    staff)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.availabilityIncTeamStatus)
                    "
                    [style.background]="
                      pickColor(getValue.availabilityIncTeamStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.availabilityIncTeamStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Availability of a dedicated full time Incubation Team
                      (Director, Chief Executive Officer and other Incubation
                      staff)
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.availabilityIncTeamStatus != 2 &&
                        getValue.availabilityIncTeamStatus != 4 &&
                        getValue.availabilityIncTeamStatus != 5 &&
                        getValue.availabilityIncTeamStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="availabilityIncTeamIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions10(
                              $event.value,
                              '.upload9',
                              9,
                              '.set-succ9'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.availabilityIncTeamIncCentre.touched &&
                              setting.availabilityIncTeamIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.availabilityIncTeamIncCentre.touched &&
                            setting.availabilityIncTeamIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.availabilityIncTeamIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options10checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website<span
                                  class="text-danger"
                                  >*</span
                                ></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="availabilityIncTeamUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'availabilityIncTeamStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.availabilityIncTeamUrlIcWebsite
                                      .touched &&
                                    setting.availabilityIncTeamUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.availabilityIncTeamUrlIcWebsite
                                    .touched &&
                                  setting.availabilityIncTeamUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.availabilityIncTeamUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.availabilityIncTeamUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload9">
                                  <input
                                    type="file"
                                    formControlName="availabilityIncTeamImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload9',
                                        9,
                                        '.set-succ9'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.availabilityIncTeamImagefile
                                          .touched &&
                                        setting.availabilityIncTeamImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.availabilityIncTeamImagefile
                                      .touched &&
                                    setting.availabilityIncTeamImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.availabilityIncTeamImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload9"
                                  (click)="
                                    removeFile('.upload9', 9, '.set-succ9')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.availabilityIncTeamStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.availabilityIncTeamReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.availabilityIncTeamStatus == 2 ||
                        getValue.availabilityIncTeamStatus == 4 ||
                        getValue.availabilityIncTeamStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.availabilityIncTeamIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.availabilityIncTeamdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.availabilityIncTeamStatus == 3 ||
                            getValue.availabilityIncTeamStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.availabilityIncTeamReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Overall experience of Incubation Staff in Startup Ecosystem
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.overallExperienceStatus)"
                    [style.background]="
                      pickColor(getValue.overallExperienceStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                    27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.overallExperienceStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Overall experience of Incubation Staff in Startup
                      Ecosystem
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.overallExperienceStatus != 2 &&
                        getValue.overallExperienceStatus != 4 &&
                        getValue.overallExperienceStatus != 5 &&
                        getValue.overallExperienceStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="overallExperienceIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionstwo(
                              $event.value,
                              '.upload1',
                              1,
                              '.set-succ1'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.overallExperienceIncCentre.touched &&
                              setting.overallExperienceIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.overallExperienceIncCentre.touched &&
                            setting.overallExperienceIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.overallExperienceIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionstwochecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >Cumulative Work Experience
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter Cumulative Work Experience"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="overallExperienceTotalYearOfExperience"
                                (change)="
                                  setStatus(
                                    $event,
                                    'overallExperienceStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .overallExperienceTotalYearOfExperience
                                      .touched &&
                                    setting
                                      .overallExperienceTotalYearOfExperience
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.overallExperienceTotalYearOfExperience
                                    .touched &&
                                  setting.overallExperienceTotalYearOfExperience
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .overallExperienceTotalYearOfExperience
                                      .errors.required
                                  "
                                  >Cumulative Work Experience is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload1">
                                  <input
                                    type="file"
                                    formControlName="overallExperienceImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload1',
                                        1,
                                        '.set-succ1'
                                      )
                                    "
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.overallExperienceImagefile
                                          .touched &&
                                        setting.overallExperienceImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.overallExperienceImagefile
                                      .touched &&
                                    setting.overallExperienceImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.overallExperienceImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload1"
                                  (click)="
                                    removeFile('.upload1', 1, '.set-succ1')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.overallExperienceStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.overallExperienceReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.overallExperienceStatus == 2 ||
                        getValue.overallExperienceStatus == 4 ||
                        getValue.overallExperienceStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.overallExperienceIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            Cumulative Work Experience :
                            <b>{{
                              getValue.overallExperienceTotalYearOfExperience
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.overallExperienceDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.overallExperienceStatus == 3 ||
                            getValue.overallExperienceStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.overallExperienceReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex title_dco">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Capacity development program for Incubation staff. Number of
                    Training programs attended by the Management team members to
                    acquire management skills and best practices
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.capacityDevelopmentProgramStatus)
                    "
                    [style.background]="
                      pickColor(getValue.capacityDevelopmentProgramStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.capacityDevelopmentProgramStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Capacity development program for Incubation staff. Number
                      of Training programs attended by the Management team
                      members to acquire management skills and best practices
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.capacityDevelopmentProgramStatus != 2 &&
                        getValue.capacityDevelopmentProgramStatus != 4 &&
                        getValue.capacityDevelopmentProgramStatus != 5 &&
                        getValue.capacityDevelopmentProgramStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="capacityDevelopmentProgramIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsthree(
                              $event.value,
                              '.upload2',
                              2,
                              '.set-succ2'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.capacityDevelopmentProgramIncCentre
                                .touched &&
                              setting.capacityDevelopmentProgramIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.capacityDevelopmentProgramIncCentre
                              .touched &&
                            setting.capacityDevelopmentProgramIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.capacityDevelopmentProgramIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsthreechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Programs attended by the Incubation
                                Staff
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Programs attended by the Incubation Staff"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'capacityDevelopmentProgramStatus',
                                    7
                                  )
                                "
                                formControlName="capacityDevelopmentProgramNoOfTraining"
                                [ngClass]="{
                                  'is-invalid':
                                    setting
                                      .capacityDevelopmentProgramNoOfTraining
                                      .touched &&
                                    setting
                                      .capacityDevelopmentProgramNoOfTraining
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.capacityDevelopmentProgramNoOfTraining
                                    .touched &&
                                  setting.capacityDevelopmentProgramNoOfTraining
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting
                                      .capacityDevelopmentProgramNoOfTraining
                                      .errors.required
                                  "
                                  >No. of Programs attended by the Incubation
                                  Staff is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload2">
                                  <input
                                    type="file"
                                    formControlName="capacityDevelopmentProgramImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload2',
                                        2,
                                        '.set-succ2'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting
                                          .capacityDevelopmentProgramImagefile
                                          .touched &&
                                        setting
                                          .capacityDevelopmentProgramImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Certificate
                                  </span>
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.capacityDevelopmentProgramImagefile
                                      .touched &&
                                    setting.capacityDevelopmentProgramImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting
                                        .capacityDevelopmentProgramImagefile
                                        .errors.required
                                    "
                                    >Certificate is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload2"
                                  (click)="
                                    removeFile('.upload2', 2, '.set-succ2')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Certificate </span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.capacityDevelopmentProgramStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.capacityDevelopmentProgramReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.capacityDevelopmentProgramStatus == 2 ||
                        getValue.capacityDevelopmentProgramStatus == 4 ||
                        getValue.capacityDevelopmentProgramStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.capacityDevelopmentProgramIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Programs attended by the Incubation Staff :
                            <b>{{
                              getValue.capacityDevelopmentProgramNoOfTraining
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.capacityDevelopmentProgramDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.capacityDevelopmentProgramStatus == 3 ||
                            getValue.capacityDevelopmentProgramStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.capacityDevelopmentProgramReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Human Resources policy for Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.humanResourcesStatus)"
                    [style.background]="
                      pickColor(getValue.humanResourcesStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.humanResourcesStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Human Resources policy for Incubation Centre</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.humanResourcesStatus != 2 &&
                        getValue.humanResourcesStatus != 4 &&
                        getValue.humanResourcesStatus != 5 &&
                        getValue.humanResourcesStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="humanResourcesIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsfour(
                              $event.value,
                              '.upload3',
                              3,
                              '.set-succ3'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.humanResourcesIncCentre.touched &&
                              setting.humanResourcesIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.humanResourcesIncCentre.touched &&
                            setting.humanResourcesIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.humanResourcesIncCentre.errors.required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfourchecked == 'Yes'">
                        <div class="main-wrapper">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload3">
                              <input
                                type="file"
                                formControlName="humanResourcesImagefile"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload3',
                                    3,
                                    '.set-succ3'
                                  )
                                "
                                accept=".pdf,.jpeg,.png,.jpg"
                                id=""
                                [ngClass]="{
                                  'is-invalid':
                                    setting.humanResourcesImagefile.touched &&
                                    setting.humanResourcesImagefile.errors
                                }"
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary</span
                              >
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Successfully</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.humanResourcesImagefile.touched &&
                                setting.humanResourcesImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.humanResourcesImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload3"
                              (click)="removeFile('.upload3', 3, '.set-succ3')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.humanResourcesStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.humanResourcesReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.humanResourcesStatus == 2 ||
                        getValue.humanResourcesStatus == 4 ||
                        getValue.humanResourcesStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.humanResourcesIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.humanResourcesDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.humanResourcesStatus == 3 ||
                            getValue.humanResourcesStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.humanResourcesReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    SOP for Workspace / Labs / Infrastructure
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.workspaceLabsInfraStatus)"
                    [style.background]="
                      pickColor(getValue.workspaceLabsInfraStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.workspaceLabsInfraStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>SOP for Workspace / Labs / Infrastructure</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.workspaceLabsInfraStatus != 2 &&
                        getValue.workspaceLabsInfraStatus != 4 &&
                        getValue.workspaceLabsInfraStatus != 5 &&
                        getValue.workspaceLabsInfraStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="workspaceLabsInfraIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsfive(
                              $event.value,
                              '.upload4',
                              4,
                              '.set-succ4'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.workspaceLabsInfraIncCentre.touched &&
                              setting.workspaceLabsInfraIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.workspaceLabsInfraIncCentre.touched &&
                            setting.workspaceLabsInfraIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.workspaceLabsInfraIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionsfivechecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of SOPs for different operations
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of SOPs for different operations"
                                (change)="
                                  setStatus(
                                    $event,
                                    'workspaceLabsInfraStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="workspaceLabsInfraNoOfSOP"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.workspaceLabsInfraNoOfSOP.touched &&
                                    setting.workspaceLabsInfraNoOfSOP.errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.workspaceLabsInfraNoOfSOP.touched &&
                                  setting.workspaceLabsInfraNoOfSOP.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.workspaceLabsInfraNoOfSOP.errors
                                      .required
                                  "
                                  >No. of SOPs for different operations is
                                  required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload4">
                                  <input
                                    type="file"
                                    formControlName="workspaceLabsInfraImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload4',
                                        4,
                                        '.set-succ4'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.workspaceLabsInfraImagefile
                                          .touched &&
                                        setting.workspaceLabsInfraImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.workspaceLabsInfraImagefile
                                      .touched &&
                                    setting.workspaceLabsInfraImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.workspaceLabsInfraImagefile.errors
                                        .required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload4"
                                  (click)="
                                    removeFile('.upload4', 4, '.set-succ4')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.workspaceLabsInfraStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.workspaceLabsInfraReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.workspaceLabsInfraStatus == 2 ||
                        getValue.workspaceLabsInfraStatus == 4 ||
                        getValue.workspaceLabsInfraStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.workspaceLabsInfraIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of SOPs for different operations :
                            <b>{{ getValue.workspaceLabsInfraNoOfSOP }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.workspaceLabsInfraDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.workspaceLabsInfraStatus == 3 ||
                            getValue.workspaceLabsInfraStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.workspaceLabsInfraReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header>
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Trained or skilled manpower for the laboratory or to operate
                    machineries
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.trainedSkilledManpowerStatus)
                    "
                    [style.background]="
                      pickColor(getValue.trainedSkilledManpowerStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.trainedSkilledManpowerStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Trained or skilled manpower for the laboratory or to
                      operate machineries
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.trainedSkilledManpowerStatus != 2 &&
                        getValue.trainedSkilledManpowerStatus != 4 &&
                        getValue.trainedSkilledManpowerStatus != 5 &&
                        getValue.trainedSkilledManpowerStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="trainedSkilledManpowerIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionssix(
                              $event.value,
                              '.upload5',
                              5,
                              '.set-succ5'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.trainedSkilledManpowerIncCentre.touched &&
                              setting.trainedSkilledManpowerIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.trainedSkilledManpowerIncCentre.touched &&
                            setting.trainedSkilledManpowerIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.trainedSkilledManpowerIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionssixchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >No. of Skilled manpower
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter No. of Skilled manpower"
                                (change)="
                                  setStatus(
                                    $event,
                                    'trainedSkilledManpowerStatus',
                                    7
                                  )
                                "
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                formControlName="trainedSkilledManpowerNoOfManpower"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.trainedSkilledManpowerNoOfManpower
                                      .touched &&
                                    setting.trainedSkilledManpowerNoOfManpower
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.trainedSkilledManpowerNoOfManpower
                                    .touched &&
                                  setting.trainedSkilledManpowerNoOfManpower
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.trainedSkilledManpowerNoOfManpower
                                      .errors.required
                                  "
                                  >No. of Skilled manpower is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload5">
                                  <input
                                    type="file"
                                    formControlName="trainedSkilledManpowerImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload5',
                                        5,
                                        '.set-succ5'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.trainedSkilledManpowerImagefile
                                          .touched &&
                                        setting.trainedSkilledManpowerImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.trainedSkilledManpowerImagefile
                                      .touched &&
                                    setting.trainedSkilledManpowerImagefile
                                      .errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.trainedSkilledManpowerImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload5"
                                  (click)="
                                    removeFile('.upload5', 5, '.set-succ5')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.trainedSkilledManpowerStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(
                                getValue.trainedSkilledManpowerReason
                              )
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.trainedSkilledManpowerStatus == 2 ||
                        getValue.trainedSkilledManpowerStatus == 4 ||
                        getValue.trainedSkilledManpowerStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.trainedSkilledManpowerIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Skilled manpower :
                            <b>{{
                              getValue.trainedSkilledManpowerNoOfManpower
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.trainedSkilledManpowerDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.trainedSkilledManpowerStatus == 3 ||
                            getValue.trainedSkilledManpowerStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.trainedSkilledManpowerReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header>
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Consultants or Interns to offer support on specific domains
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.consultantsOrInternsStatus)
                    "
                    [style.background]="
                      pickColor(getValue.consultantsOrInternsStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                        27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.consultantsOrInternsStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Consultants or Interns to offer support on specific
                      domains
                    </h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.consultantsOrInternsStatus != 2 &&
                        getValue.consultantsOrInternsStatus != 4 &&
                        getValue.consultantsOrInternsStatus != 5 &&
                        getValue.consultantsOrInternsStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="consultantsOrInternsIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptionsseven(
                              $event.value,
                              '.upload6',
                              6,
                              '.set-succ6'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.consultantsOrInternsIncCentre.touched &&
                              setting.consultantsOrInternsIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No"
                            >No</mat-radio-button
                          > </mat-radio-group
                        ><br />
                        <mat-error
                          *ngIf="
                            setting.consultantsOrInternsIncCentre.touched &&
                            setting.consultantsOrInternsIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.consultantsOrInternsIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Optionssevenchecked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                ><span class="text-danger">*</span> No. of
                                Interns / Consultants operating in the
                                Incubation Centre
                              </mat-label>
                              <input
                                matInput
                                placeholder="Enter No. of Interns / Consultants operating in the Incubation Centre"
                                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
                                (change)="
                                  setStatus(
                                    $event,
                                    'consultantsOrInternsStatus',
                                    7
                                  )
                                "
                                formControlName="consultantsOrInternsNoOfConsultants"
                                [ngClass]="{
                                  'is-invalid':
                                    setting.consultantsOrInternsNoOfConsultants
                                      .touched &&
                                    setting.consultantsOrInternsNoOfConsultants
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.consultantsOrInternsNoOfConsultants
                                    .touched &&
                                  setting.consultantsOrInternsNoOfConsultants
                                    .errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.consultantsOrInternsNoOfConsultants
                                      .errors.required
                                  "
                                  >No. of Interns / Consultants operating in the
                                  Incubation Centre is required</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload6">
                                  <input
                                    type="file"
                                    formControlName="consultantsOrInternsImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload6',
                                        6,
                                        '.set-succ6'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.consultantsOrInternsImagefile
                                          .touched &&
                                        setting.consultantsOrInternsImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.consultantsOrInternsImagefile
                                      .touched &&
                                    setting.consultantsOrInternsImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.consultantsOrInternsImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload6"
                                  (click)="
                                    removeFile('.upload6', 6, '.set-succ6')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.consultantsOrInternsStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.consultantsOrInternsReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.consultantsOrInternsStatus == 2 ||
                        getValue.consultantsOrInternsStatus == 4 ||
                        getValue.consultantsOrInternsStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.consultantsOrInternsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            No. of Interns / Consultants operating in the
                            Incubation Centre :
                            <b>{{
                              getValue.consultantsOrInternsNoOfConsultants
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.consultantsOrInternsDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.consultantsOrInternsStatus == 3 ||
                            getValue.consultantsOrInternsStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.consultantsOrInternsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 010 -->
            <!-- <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
                            <mat-expansion-panel-header class="d-flex">
                                <h6>08.&nbsp;</h6>                               
                                <h6>
                                    <span *ngIf="mobileQuery.matches==false">
                                        Shared HR Management expertise / mentors available for the startups.           
                                    </span>
                                    <span *ngIf="mobileQuery.matches==true">Question</span>
                                </h6>
                                <div class="success-span ml-auto">
                                    <div class="set success"
                                        [style.width]="pickWidth(getValue.grievencesRedressalStatus)"
                                        [style.background]="pickColor(getValue.grievencesRedressalStatus)">
                                        <svg version="1.1" id="check" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                            viewBox="0 0 100 100" xml:space="preserve">
                                            <circle
                                                style="fill:rgba(0,0,0,0);stroke:#ffffff;stroke-width:10;stroke-miterlimit:10;"
                                                cx="49.799" cy="49.746" r="44.757" />
                                            <polyline
                                                style="fill:rgba(0,0,0,0);stroke:#ffffff;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                                                points="
                                                27.114,51 41.402,65.288 72.485,34.205 " />
                                        </svg> <span
                                            [innerHTML]="innerValue(getValue.grievencesRedressalStatus)"></span>
                                    </div>
                                </div>
                            </mat-expansion-panel-header>
                            <div class="answer-div">
                            <div class="row">
                                <div class="col-12 mb-2" *ngIf="mobileQuery.matches==true">
                                    <h6>Shared HR Management expertise / mentors available for the startups.</h6>
                                </div>
                                <div class="col-lg-8 col-md-8 col-12">
                                    <div *ngIf="getValue.grievencesRedressalStatus!=2 && 
                                    getValue.grievencesRedressalStatus!=4 && getValue.grievencesRedressalStatus!=5 && getValue.grievencesRedressalStatus!=6">
                                        <div class="mt-3">
                                            <mat-radio-group formControlName="grievencesRedressalIncCentre"
                                                class="example-margin mt-4" aria-label="Select an option"
                                                (change)="showOptions10($event.value,'.upload9',9,'.set-succ9')"
                                                [ngClass]="{ 'is-invalid': setting.grievencesRedressalIncCentre.touched && setting.grievencesRedressalIncCentre.errors }">
                                                <mat-radio-button value="Yes">Yes</mat-radio-button>
                                                <mat-radio-button value="No">No</mat-radio-button>
                                            </mat-radio-group> <br>
                                            <mat-error
                                                *ngIf="setting.grievencesRedressalIncCentre.touched && setting.grievencesRedressalIncCentre.errors">
                                                <span *ngIf="setting.grievencesRedressalIncCentre.errors.required">Answer
                                                    is
                                                    required</span>
                                            </mat-error>
                                        </div>
                                        <div class="opt-div" *ngIf="Options10checked=='Yes'">
                                            <div class="main-wrapper">
                                                <div class="upload-main-wrapper">
                                                    <div class="upload-wrapper upload9">
                                                        <input type="file" formControlName="grievencesRedressalImagefile"
                                                            (change)="fileUpload($event,'.upload9',9,'.set-succ9')"
                                                            accept=".pdf,.jpeg,.png,.jpg" id=""
                                                            [ngClass]="{ 'is-invalid': setting.grievencesRedressalImagefile.touched && setting.grievencesRedressalImagefile.errors }">
                                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            preserveAspectRatio="xMidYMid meet"
                                                            viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                                            width="221.13" height="178.85">
                                                            <defs>
                                                                <path
                                                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                                                    id="b1aO7LLtdW"></path>
                                                                <path
                                                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                                                    id="c4SXvvMdYD"></path>
                                                                <path
                                                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                                                    id="b11si2zUk"></path>
                                                            </defs>
                                                            <g>
                                                                <g>
                                                                    <g>
                                                                        <use xlink:href="#b1aO7LLtdW" opacity="1" fill="#ffffff"
                                                                            fill-opacity="1"></use>
                                                                    </g>
                                                                    <g>
                                                                        <g>
                                                                            <use xlink:href="#c4SXvvMdYD" opacity="1"
                                                                                fill="#363535" fill-opacity="1"></use>
                                                                        </g>
                                                                        <g>
                                                                            <use xlink:href="#b11si2zUk" opacity="1"
                                                                                fill="#363535" fill-opacity="1"></use>
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                        <span class="file-upload-text">Upload Documentary</span>
                                                        <div class="file-success-text">
                                                            <svg version="1.1" id="check" xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                                viewBox="0 0 100 100" xml:space="preserve">
                                                                <circle
                                                                    style="fill:rgba(0,0,0,0);stroke:#ffffff;stroke-width:10;stroke-miterlimit:10;"
                                                                    cx="49.799" cy="49.746" r="44.757" />
                                                                <polyline
                                                                    style="fill:rgba(0,0,0,0);stroke:#ffffff;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                                                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 " />
                                                            </svg> <span>Successfully</span>
                                                        </div>
                                                    </div>
                                                    <mat-error
                                                        *ngIf="setting.grievencesRedressalImagefile.touched && setting.grievencesRedressalImagefile.errors">
                                                        <span
                                                            *ngIf="setting.grievencesRedressalImagefile.errors.required">Documentary
                                                            is
                                                            required</span>
                                                    </mat-error>
                                                    <div class="remove-wrapper upload9"
                                                        (click)="removeFile('.upload9',9,'.set-succ9')">
                                                        <div class="file-success-text">
                                                            <ion-icon name="close-circle-outline"></ion-icon><span>Remove
                                                                Documentary</span>
                                                        </div>
                                                    </div>
                                                    <p> <span class="noti-span">(Supported Format: png,jpg,jpeg,pdf) <br>(max
                                                            file size:
                                                            10mb)</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center mt-3" *ngIf="getValue.grievencesRedressalStatus==3">
                                            <button class="custom-btn btn-12"><span
                                                    (click)="viewReasonBtn(getValue.grievencesRedressalReason)">Click!</span><span>Reason</span></button>
                                        </div>
                                    </div>
                                    <div class="submitted-details"
                                            *ngIf="getValue.grievencesRedressalStatus==2 ||getValue.grievencesRedressalStatus==4 || getValue.grievencesRedressalStatus==6">
                                            <div class="submiited-header">
                                                <div class="name-header d-flex">
                                                    <span class="material-icons">fact_check</span> <span
                                                        class="ml-1">Submitted Details :</span>
                                                </div>
                                            </div>
                                            <div class="submitted-content">
                                                <div class="sub-div">
                                                    <p class="p-lbl">Option Selected :
                                                        <b>{{getValue.grievencesRedressalIncCentre}}</b>
                                                    </p>
                                                </div>                                                
                                                <div class="sub-div">
                                                    <p class="p-lbl">Supporting Documents</p>
                                                    <ul class="sub-ul">
                                                        <li *ngFor="let list of getValue.grievencesRedressalDocuments">
                                                            <a href="{{list.documentName}}"
                                                                target="_blank">{{list.documentName}}</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="sub-div" *ngIf="getValue.grievencesRedressalStatus==3 || getValue.grievencesRedressalStatus==6">
                                                    <p class="p-lbl">Reason for clarification</p>
                                                    <p class="c-black comments">{{getValue.grievencesRedressalReason}}</p>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-12">
                                    <div class="guideline-div d-flex"
                                        (click)="guidelinesBtn(guidelineValue[9].Guidelines)">
                                        <span class="material-icons">description</span> <span
                                            class="ml-1">Guidelines</span>
                                    </div>
                                   
                                </div>
                            </div>   
                            
                            </div>
                            <mat-action-row>
                                <button mat-button color="warn" (click)="prevStep()">Previous</button>
                                <button mat-button color="primary" (click)="nextStep()">Save & Continue</button>
                            </mat-action-row>
                        </mat-expansion-panel> -->
            <!-- qusetion 008 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Grievences redressal mechanism
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.grievencesRedressalStatus)
                    "
                    [style.background]="
                      pickColor(getValue.grievencesRedressalStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.grievencesRedressalStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Grievences redressal mechanism</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.grievencesRedressalStatus != 2 &&
                        getValue.grievencesRedressalStatus != 4 &&
                        getValue.grievencesRedressalStatus != 5 &&
                        getValue.grievencesRedressalStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="grievencesRedressalIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions8(
                              $event.value,
                              '.upload7',
                              7,
                              '.set-succ7'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.grievencesRedressalIncCentre.touched &&
                              setting.grievencesRedressalIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.grievencesRedressalIncCentre.touched &&
                            setting.grievencesRedressalIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.grievencesRedressalIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options8checked == 'Yes'">
                        <div class="row">
                          <div class="col-lg-6 col-md-6 col-12">
                            <mat-form-field
                              class="material-full-width"
                              appearance="outline"
                            >
                              <mat-label
                                >URL from Incubation Center Website
                                <span class="text-danger">*</span></mat-label
                              >
                              <input
                                matInput
                                placeholder="Enter URL from Incubation Center Website"
                                formControlName="grievencesRedressalUrlIcWebsite"
                                (change)="
                                  setStatus(
                                    $event,
                                    'grievencesRedressalStatus',
                                    7
                                  )
                                "
                                [ngClass]="{
                                  'is-invalid':
                                    setting.grievencesRedressalUrlIcWebsite
                                      .touched &&
                                    setting.grievencesRedressalUrlIcWebsite
                                      .errors
                                }"
                              />
                              <mat-error
                                *ngIf="
                                  setting.grievencesRedressalUrlIcWebsite
                                    .touched &&
                                  setting.grievencesRedressalUrlIcWebsite.errors
                                "
                              >
                                <span
                                  *ngIf="
                                    setting.grievencesRedressalUrlIcWebsite
                                      .errors.required
                                  "
                                  >URL from Incubation Center Website is
                                  required</span
                                >
                                <span
                                  *ngIf="
                                    setting.grievencesRedressalUrlIcWebsite
                                      .errors.url
                                  "
                                  >Please enter proper url format</span
                                >
                              </mat-error>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-6 col-md-6 col-12">
                            <div class="main-wrapper">
                              <div class="upload-main-wrapper">
                                <div class="upload-wrapper upload7">
                                  <input
                                    type="file"
                                    formControlName="grievencesRedressalImagefile"
                                    (change)="
                                      fileUpload(
                                        $event,
                                        '.upload7',
                                        7,
                                        '.set-succ7'
                                      )
                                    "
                                    accept=".pdf,.jpeg,.png,.jpg"
                                    id=""
                                    [ngClass]="{
                                      'is-invalid':
                                        setting.grievencesRedressalImagefile
                                          .touched &&
                                        setting.grievencesRedressalImagefile
                                          .errors
                                    }"
                                  />
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    preserveAspectRatio="xMidYMid meet"
                                    viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                    width="221.13"
                                    height="178.85"
                                  >
                                    <defs>
                                      <path
                                        d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                        id="b1aO7LLtdW"
                                      ></path>
                                      <path
                                        d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                        id="c4SXvvMdYD"
                                      ></path>
                                      <path
                                        d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                        id="b11si2zUk"
                                      ></path>
                                    </defs>
                                    <g>
                                      <g>
                                        <g>
                                          <use
                                            xlink:href="#b1aO7LLtdW"
                                            opacity="1"
                                            fill="#ffffff"
                                            fill-opacity="1"
                                          ></use>
                                        </g>
                                        <g>
                                          <g>
                                            <use
                                              xlink:href="#c4SXvvMdYD"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                          <g>
                                            <use
                                              xlink:href="#b11si2zUk"
                                              opacity="1"
                                              fill="#363535"
                                              fill-opacity="1"
                                            ></use>
                                          </g>
                                        </g>
                                      </g>
                                    </g>
                                  </svg>
                                  <span class="file-upload-text"
                                    >Upload Documentary</span
                                  >
                                  <div class="file-success-text">
                                    <svg
                                      version="1.1"
                                      id="check"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xmlns:xlink="http://www.w3.org/1999/xlink"
                                      x="0px"
                                      y="0px"
                                      viewBox="0 0 100 100"
                                      xml:space="preserve"
                                    >
                                      <circle
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-miterlimit: 10;
                                        "
                                        cx="49.799"
                                        cy="49.746"
                                        r="44.757"
                                      />
                                      <polyline
                                        style="
                                          fill: rgba(0, 0, 0, 0);
                                          stroke: #ffffff;
                                          stroke-width: 10;
                                          stroke-linecap: round;
                                          stroke-linejoin: round;
                                          stroke-miterlimit: 10;
                                        "
                                        points="
                                                                    27.114,51 41.402,65.288 72.485,34.205 "
                                      />
                                    </svg>
                                    <span>Successfully</span>
                                  </div>
                                </div>
                                <mat-error
                                  *ngIf="
                                    setting.grievencesRedressalImagefile
                                      .touched &&
                                    setting.grievencesRedressalImagefile.errors
                                  "
                                >
                                  <span
                                    *ngIf="
                                      setting.grievencesRedressalImagefile
                                        .errors.required
                                    "
                                    >Documentary is required</span
                                  >
                                </mat-error>
                                <div
                                  class="remove-wrapper upload7"
                                  (click)="
                                    removeFile('.upload7', 7, '.set-succ7')
                                  "
                                >
                                  <div class="file-success-text">
                                    <ion-icon
                                      name="close-circle-outline"
                                    ></ion-icon
                                    ><span>Remove Documentary</span>
                                  </div>
                                </div>
                                <p>
                                  <span class="noti-span"
                                    >(Supported Format: png,jpg,jpeg,pdf)
                                    <br />(max file size: 10mb)</span
                                  >
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.grievencesRedressalStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.grievencesRedressalReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.grievencesRedressalStatus == 2 ||
                        getValue.grievencesRedressalStatus == 4 ||
                        getValue.grievencesRedressalStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.grievencesRedressalIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.grievencesRedressalUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.grievencesRedressalUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.grievencesRedressalDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.grievencesRedressalStatus == 3 ||
                            getValue.grievencesRedressalStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.grievencesRedressalReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 009 -->
            <mat-expansion-panel [expanded]="step === 8" (opened)="setStep(8)">
              <mat-expansion-panel-header class="d-flex">
                <h6>09.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Exit interview policy
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.exitInterviewPolicyStatus)
                    "
                    [style.background]="
                      pickColor(getValue.exitInterviewPolicyStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.exitInterviewPolicyStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>Exit interview policy</h6>
                  </div>
                  <div class="col-lg-8 col-md-8 col-12">
                    <div
                      *ngIf="
                        getValue.exitInterviewPolicyStatus != 2 &&
                        getValue.exitInterviewPolicyStatus != 4 &&
                        getValue.exitInterviewPolicyStatus != 5 &&
                        getValue.exitInterviewPolicyStatus != 6
                      "
                    >
                      <div class="mt-3">
                        <mat-radio-group
                          formControlName="exitInterviewPolicyIncCentre"
                          class="example-margin mt-4"
                          aria-label="Select an option"
                          (change)="
                            showOptions9(
                              $event.value,
                              '.upload8',
                              8,
                              '.set-succ8'
                            )
                          "
                          [ngClass]="{
                            'is-invalid':
                              setting.exitInterviewPolicyIncCentre.touched &&
                              setting.exitInterviewPolicyIncCentre.errors
                          }"
                        >
                          <mat-radio-button value="Yes">Yes</mat-radio-button>
                          <mat-radio-button value="No">No</mat-radio-button>
                        </mat-radio-group>
                        <br />
                        <mat-error
                          *ngIf="
                            setting.exitInterviewPolicyIncCentre.touched &&
                            setting.exitInterviewPolicyIncCentre.errors
                          "
                        >
                          <span
                            *ngIf="
                              setting.exitInterviewPolicyIncCentre.errors
                                .required
                            "
                            >Answer is required</span
                          >
                        </mat-error>
                      </div>
                      <div class="opt-div" *ngIf="Options9checked == 'Yes'">
                        <div class="main-wrapper">
                          <div class="upload-main-wrapper">
                            <div class="upload-wrapper upload8">
                              <input
                                type="file"
                                formControlName="exitInterviewPolicyImagefile"
                                (change)="
                                  fileUpload(
                                    $event,
                                    '.upload8',
                                    8,
                                    '.set-succ8'
                                  )
                                "
                                accept=".pdf,.jpeg,.png,.jpg"
                                id=""
                                [ngClass]="{
                                  'is-invalid':
                                    setting.exitInterviewPolicyImagefile
                                      .touched &&
                                    setting.exitInterviewPolicyImagefile.errors
                                }"
                              />
                              <svg
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                preserveAspectRatio="xMidYMid meet"
                                viewBox="224.3881704980842 176.8527621722847 221.13266283524905 178.8472378277154"
                                width="221.13"
                                height="178.85"
                              >
                                <defs>
                                  <path
                                    d="M357.38 176.85C386.18 176.85 409.53 204.24 409.53 238.02C409.53 239.29 409.5 240.56 409.42 241.81C430.23 246.95 445.52 264.16 445.52 284.59C445.52 284.59 445.52 284.59 445.52 284.59C445.52 309.08 423.56 328.94 396.47 328.94C384.17 328.94 285.74 328.94 273.44 328.94C246.35 328.94 224.39 309.08 224.39 284.59C224.39 284.59 224.39 284.59 224.39 284.59C224.39 263.24 241.08 245.41 263.31 241.2C265.3 218.05 281.96 199.98 302.22 199.98C306.67 199.98 310.94 200.85 314.93 202.46C324.4 186.96 339.88 176.85 357.38 176.85Z"
                                    id="b1aO7LLtdW"
                                  ></path>
                                  <path
                                    d="M306.46 297.6L339.79 297.6L373.13 297.6L339.79 255.94L306.46 297.6Z"
                                    id="c4SXvvMdYD"
                                  ></path>
                                  <path
                                    d="M350.79 293.05L328.79 293.05L328.79 355.7L350.79 355.7L350.79 293.05Z"
                                    id="b11si2zUk"
                                  ></path>
                                </defs>
                                <g>
                                  <g>
                                    <g>
                                      <use
                                        xlink:href="#b1aO7LLtdW"
                                        opacity="1"
                                        fill="#ffffff"
                                        fill-opacity="1"
                                      ></use>
                                    </g>
                                    <g>
                                      <g>
                                        <use
                                          xlink:href="#c4SXvvMdYD"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                      <g>
                                        <use
                                          xlink:href="#b11si2zUk"
                                          opacity="1"
                                          fill="#363535"
                                          fill-opacity="1"
                                        ></use>
                                      </g>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                              <span class="file-upload-text"
                                >Upload Documentary</span
                              >
                              <div class="file-success-text">
                                <svg
                                  version="1.1"
                                  id="check"
                                  xmlns="http://www.w3.org/2000/svg"
                                  xmlns:xlink="http://www.w3.org/1999/xlink"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 100 100"
                                  xml:space="preserve"
                                >
                                  <circle
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-miterlimit: 10;
                                    "
                                    cx="49.799"
                                    cy="49.746"
                                    r="44.757"
                                  />
                                  <polyline
                                    style="
                                      fill: rgba(0, 0, 0, 0);
                                      stroke: #ffffff;
                                      stroke-width: 10;
                                      stroke-linecap: round;
                                      stroke-linejoin: round;
                                      stroke-miterlimit: 10;
                                    "
                                    points="
                                                            27.114,51 41.402,65.288 72.485,34.205 "
                                  />
                                </svg>
                                <span>Successfully</span>
                              </div>
                            </div>
                            <mat-error
                              *ngIf="
                                setting.exitInterviewPolicyImagefile.touched &&
                                setting.exitInterviewPolicyImagefile.errors
                              "
                            >
                              <span
                                *ngIf="
                                  setting.exitInterviewPolicyImagefile.errors
                                    .required
                                "
                                >Documentary is required</span
                              >
                            </mat-error>
                            <div
                              class="remove-wrapper upload8"
                              (click)="removeFile('.upload8', 8, '.set-succ8')"
                            >
                              <div class="file-success-text">
                                <ion-icon name="close-circle-outline"></ion-icon
                                ><span>Remove Documentary</span>
                              </div>
                            </div>
                            <p>
                              <span class="noti-span"
                                >(Supported Format: png,jpg,jpeg,pdf) <br />(max
                                file size: 10mb)</span
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        class="text-center mt-3"
                        *ngIf="getValue.exitInterviewPolicyStatus == 3"
                      >
                        <button class="custom-btn btn-12">
                          <span
                            (click)="
                              viewReasonBtn(getValue.exitInterviewPolicyReason)
                            "
                            >Click!</span
                          ><span>Reason</span>
                        </button>
                      </div>
                    </div>
                    <div
                      class="submitted-details"
                      *ngIf="
                        getValue.exitInterviewPolicyStatus == 2 ||
                        getValue.exitInterviewPolicyStatus == 4 ||
                        getValue.exitInterviewPolicyStatus == 6
                      "
                    >
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.exitInterviewPolicyIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.exitInterviewPolicyDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="
                            getValue.exitInterviewPolicyStatus == 3 ||
                            getValue.exitInterviewPolicyStatus == 6
                          "
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.exitInterviewPolicyReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[8])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
